export default {
  mutations: {
    SET_WITHDRAWALS: 'SET_WITHDRAWALS',
    SET_LOADING: 'SET_LOADING',
  },
  getters: {
    GET_WITHDRAWALS: 'GET_WITHDRAWALS',
    GET_WITHDRAWALS_PAGINATION: 'GET_WITHDRAWALS_PAGINATION',
    GET_LOADING: 'GET_LOADING',
  },
  actions: {
    WITHDRAWAL_LIST: 'WITHDRAWAL_LIST',
    WITHDRAWAL_CREATE: 'WITHDRAWAL_CREATE',
    WITHDRAWAL_GET_BY_ID: 'WITHDRAWAL_GET_BY_ID',
    WITHDRAWAL_BALANCE: 'WITHDRAWAL_BALANCE',
    WITHDRAWAL_BATCH: 'WITHDRAWAL_BATCH',
  },
};
